import './About.css';

const TermsAndConditions = () => {
  return (
    <div className="about-page">
      <div className="page-header">
        <div className="container">
          <h1>Terms And Conditions</h1>
          <p>Please read our terms of service</p>
        </div>
      </div>
      <section className="section">
        <div className="container">
          <div className="about-content">
            <p>This page is under construction. Please check back later for our terms and conditions.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
